import { render, staticRenderFns } from "./InvoiceDetailsReturned.vue?vue&type=template&id=a27e58b8&scoped=true&"
import script from "./InvoiceDetailsReturned.vue?vue&type=script&lang=js&"
export * from "./InvoiceDetailsReturned.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDetailsReturned.vue?vue&type=style&index=0&id=a27e58b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27e58b8",
  null
  
)

export default component.exports